import WarningTriangleGrayIcon from '@/assets/icons/V3/WarningTriangleGrayIcon.svg?react';
import { Button } from '@/components/V3/Button';
import { GA_ROUTES } from '@/constants/ga';
import { ENTERED_BY_MARKET_NAME } from '@/constants/localstorage';
import { SigninContainer } from '@/containers/auth/signin-container';
import useWebview from '@/hooks/V3/useWebview';
import { usePageView } from '@/hooks/use-page-view';
import { useResponsive } from '@/hooks/useResponsive';
import { ROUTES } from '@/routes';
import { AES } from '@/utils/AES';
import { useLayoutEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const SignInPage = () => {
  const navigate = useNavigate();

  const { isWebviewError } = useResponsive();
  const { postMessage } = useWebview();
  const cplatToken = localStorage.getItem('cplatToken');

  const enteredByMarketNameRef = useRef(localStorage.getItem(ENTERED_BY_MARKET_NAME));
  useLayoutEffect(() => {
    if (!cplatToken || cplatToken === '') return;

    const rawToken = cplatToken.replace(/^['"]|['"]$/g, '');
    const isJwt = rawToken.split('.').length === 3;
    const isEncrypted = rawToken.startsWith('U2FsdGVk');

    // 암호화된 토큰인 경우 -> 복호화 후 저장하고 이동
    if (isEncrypted && !isJwt) {
      try {
        // 복호화 시도 (rawToken 사용)
        const decrypted = AES.decryptData(rawToken);

        // 복호화 된 값이 정상 JWT인지 한 번 더 체크
        const cleanDecrypted = decrypted.replace(/^['"]|['"]$/g, '');

        if (cleanDecrypted && cleanDecrypted.split('.').length === 3) {
          localStorage.setItem('cplatToken', cleanDecrypted); // 깨끗한 토큰으로 덮어쓰기
          if (!enteredByMarketNameRef.current) {
            navigate(ROUTES.root);
          }
          return;
        }
      } catch (e) {
        console.warn('Failed to decrypt token. Clearing.');
        localStorage.removeItem('cplatToken');
        return;
      }
    }

    if (!isJwt) {
      localStorage.removeItem('cplatToken');
      return;
    }

    // 3. 정상 JWT인 경우 -> 이동
    if (cplatToken !== rawToken) {
      localStorage.setItem('cplatToken', rawToken);
    }
    if (!enteredByMarketNameRef.current) navigate(ROUTES.root);
  }, [cplatToken, navigate]);

  usePageView(GA_ROUTES.login);

  return (
    <>
      {isWebviewError ? (
        // webview 토큰 에러 발생 시, app 로그인 화면으로 reset 이동시키기
        <div className="flex h-[100dvh] flex-col items-center justify-center gap-[20px]">
          <WarningTriangleGrayIcon />
          <div className="whitespace-pre text-center text-gr-700 Body1S16">{`일시적인 오류가 발생했습니다\n잠시 후 다시 이용해 주세요`}</div>
          <Button
            variant={'SolidLow'}
            height={'44'}
            className="w-[200px]"
            onClick={() => {
              postMessage({
                action: 'resetApp',
                data: {
                  index: 0,
                  routes: [
                    {
                      key: 'Start',
                      name: 'Start',
                    },
                  ],
                },
              });
            }}
          >
            다시 로그인하기
          </Button>
        </div>
      ) : (
        <div className="scrollbar flex h-[100dvh] items-start justify-center bg-gr-50 pt-[clamp(80px,20vh,272px)] max-md:bg-white max-md:pt-20">
          {/* {renderSigninContainer()} */}
          <SigninContainer />
        </div>
      )}
    </>
  );
};

export default SignInPage;
